<template>
  <div>
    <section class="section-header-info middle-content">
      <div class="container big-container">
        <div class="row text-center">
          <div class="col-sm-12">
            <h3>Open Jobs</h3>
            <div class="table-legend">
              <ul>
                <li><i class="ic-flight-icon"></i>Airport Transfer</li>
                <li><i class="ic-time"></i>Hourly Booking</li>
              </ul>
            </div>
            <div class="data-row --blue25">
              <strong>{{ time }}</strong>
            </div>
            <div class="form-group mt-20">
              <div
                class="btn-group btn-group-toggle mb-25"
                data-toggle="buttons"
              >
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'all' }"
                  @click="changePeriods('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'today' }"
                  @click="changePeriods('today')"
                >
                  Today
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'tomorrow' }"
                  @click="changePeriods('tomorrow')"
                >
                  Tomorrow
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'next' }"
                  @click="changePeriods('next')"
                >
                  Next Day
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-selectDate"
                  :class="{ 'btn-active': period === 'range' }"
                >
                  <VueCtkDateTimePicker
                    id="jobBrowserDateRange"
                    name="jobBrowserDateRange"
                    v-model="jobBrowserDateRange"
                    color="#025BC5"
                    format="YYYY-MM-DD"
                    formatted="MMM DD"
                    range
                    no-shortcuts
                    label="Select Date"
                    no-header
                    overlay
                    no-button-now
                    button-color="#FFB733"
                    no-clear-button
                    @is-shown="showPicker()"
                    @is-hidden="hidePicker()"
                    @validate="searchRange()"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive table-manage">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Type</th>
                    <th>Code</th>
                    <th>Vehicle</th>
                    <th>Pick-Up</th>
                    <th class="text-left">Drop-Off</th>
                    <th class="text-center">Country</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="detail-row"
                    v-for="(item, index) in table.items"
                    :key="index"
                  >
                    <td class="text-center">
                      <strong>
                        <i
                          v-if="
                            isAirportTransfer(item.serviceType) &&
                            item.isPickUpAirport
                          "
                          class="ic-flight-icon"
                        ></i>
                        <i
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            item.isDropOffAirport
                          "
                          class="ic-flight-departure-icon"
                        ></i>
                        <i
                          class="ic-car-alt"
                          v-else-if="
                            isAirportTransfer(item.serviceType) &&
                            !item.isPickUpAirport &&
                            !item.isDropOffAirport
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 1200 1200"
                          >
                            <path
                              fill="currentColor"
                              d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                            />
                          </svg>
                        </i>
                        <i v-else class="ic-time"></i>
                      </strong>
                    </td>
                    <td>
                      <strong>{{ item.reservationCode }}</strong>
                      <span class="new-line" v-if="!provider">
                        {{ item.reservationDate.stringFullDate }}
                      </span>
                      <strong class="time-utc" v-if="!provider">
                        {{ item.reservationDate.stringHour }}:{{
                          item.reservationDate.stringMinute
                        }}
                        <span class="utc-style"
                          >({{ item.reservationDate.offsetName }})</span
                        >
                      </strong>
                    </td>
                    <td class="pos-rel">
                      <strong>{{ item.vehicle.className }}</strong>
                      <span class="new-line">
                        {{ item.vehicle.factoryName }}
                        {{ item.vehicle.brandName }}
                      </span>
                      <div class="row-big-menu" v-if="isAllowToRead">
                        <ul>
                          <li v-if="true">
                            <button
                              class="btn btn-default --green35"
                              type="button"
                              @click="pickupJob(item)"
                            >
                              <span>Accept Job</span>
                            </button>
                          </li>
                          <li v-if="isAllowToRead">
                            <router-link
                              :to="`/job/available/${item.reservationId}`"
                              target="_blank"
                              class="sts-warning btn btn-default"
                            >
                              Details
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <span v-if="item.isTodayPickUp">
                        <span class="sts-danger">Today</span>,
                        {{ item.pickUpDate.stringDate }}
                        {{ item.pickUpDate.stringShortMonth }}
                        {{ item.pickUpDate.year }}
                      </span>
                      <span v-else>{{ item.pickUpDate.stringFullDate }}</span>
                      <strong class="time-utc">
                        {{ item.pickUpDate.stringHour }}:{{
                          item.pickUpDate.stringMinute
                        }}
                        <span class="utc-style">
                          ({{ item.pickUpDate.offsetName }})</span
                        >
                      </strong>
                      {{ item.pickUpName }}
                    </td>
                    <td>
                      <span v-if="item.isTodayDropOff">
                        <span class="sts-danger">Today</span>,
                        {{ item.dropOffDate.stringDate }}
                        {{ item.dropOffDate.stringShortMonth }}
                        {{ item.dropOffDate.year }}
                      </span>
                      <span v-else>{{ item.dropOffDate.stringFullDate }}</span>
                      <strong class="time-utc">
                        {{ item.dropOffDate.stringHour }}:{{
                          item.dropOffDate.stringMinute
                        }}
                        <span class="utc-style"
                          >({{ item.dropOffDate.offsetName }})</span
                        >
                      </strong>
                      {{ item.dropOffName }}
                    </td>
                    <td class="text-center">
                      {{ item.country }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <div class="modal fade" role="dialog" ref="modal_subscribers">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Provider Dispatch</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mtz">
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <table class="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Provider</th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              providerName, providerId, index
                            ) in selectedJob.subscribers"
                            :key="index"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ providerName }}</td>
                            <td class="text-center">
                              <div class="button-action-wrapper">
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="
                                    openDispatchDialog(providerId, providerName)
                                  "
                                >
                                  <span>Dispatch</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :id="'OverrideConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @onCancel="cancelConfirmation()"
      @submit="dispatchJob(true, true)"
    />

    <confirmModal
      :id="'DispatchConfirmation'"
      :header="'Dispatch'"
      :content="`Are you sure you want dispatch to<br/><strong>${selectedProvider.providerName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Dispatch'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="dispatchJob(true)"
    />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import moment from "moment";
import availableJobService from "@/services/job/availableJobService";
import confirmModal from "@/components/shared/ConfirmModal";

export default {
  components: {
    confirmModal,
  },
  data() {
    return {
      isLoading: false,
      msg: "Please wait",
      period: "all",
      jobBrowserDateRange: null,
      formatter: null,
      timer: null,
      moneyFormat: {},
      selectedProvider: {
        reservationId: null,
        providerId: null,
        providerName: null,
        overrideTimingBlock: false,
      },
      selectedJob: {
        reservationId: null,
        subscribers: {},
      },
      allPermissions: [],
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        items: [],
      },
      provider: false,
      userType: "Unspecified",
    };
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToPickup: function () {
      return this.allPermissions.includes("Pickup");
    },
    time: function () {
      const date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return moment(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    this.userType = profile.userType;

    const checkRoles = profile.roles.find(
      (val) => val.toLowerCase() === "provider"
    );
    if (checkRoles) this.provider = true;
    else this.provider = false;

    const permissions = profile.services[this.$route.name];

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.search();

      if (this.moneyFormat) {
        this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
          style: "currency",
          currency: this.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: this.moneyFormat.numberOfDecimal,
        });
      }
    }
  },
  updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("available-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    convertPeriod() {
      let result = "";
      const date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = `today_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = `tomorrow_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = `next_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "range":
          result = `range_${this.jobBrowserDateRange.start}_${this.jobBrowserDateRange.end}`;
          break;
      }
      return result;
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    openDispatchDialog(providerId, providerName) {
      this.selectedProvider.providerId = providerId;
      this.selectedProvider.providerName = providerName;
      $("#DispatchConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    clearPayload() {
      this.selectedProvider = {
        reservationId: null,
        providerId: null,
        providerName: null,
        overrideTimingBlock: false,
      };
      this.selectedJob = { reservationId: null, subscribers: {} };
    },
    async changePeriods(period) {
      this.period = period;
      await this.search();
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.search();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.search();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.search();
    },
    async search() {
      let filter = `?page=${this.table.pageNumber}&size=${
        this.table.pageSize
      }&data=${this.convertPeriod()}`;

      if (this.table.keyword !== null && this.table.keyword !== "") {
        filter += `&search=${this.table.keyword}`;
      }

      const response = await availableJobService.search(
        filter,
        this.startLoader,
        this.stopLoader
      );

      if (response.isSuccess) {
        this.moneyFormat = response.data.moneyFormat;
        this.table.items = response.data.items;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      }
    },
    async searchRange() {
      if (
        !this.jobBrowserDateRange.start ||
        this.jobBrowserDateRange.start === "" ||
        !this.jobBrowserDateRange.end ||
        this.jobBrowserDateRange.end === ""
      ) {
        alert("Please select a date range.");
        return;
      }
      this.hidePicker();
      await this.changePeriods("range");
    },
    async pickupJob(job) {
      if (job.providers.length > 1) {
        const response = await availableJobService.getSubscribers(
          job.reservationId,
          this.startLoader,
          this.stopLoader
        );

        if (response.isSuccess) {
          this.selectedProvider.reservationId = job.reservationId;
          this.selectedJob = {
            reservationId: job.reservationId,
            subscribers: response.data,
          };

          $(this.$refs.modal_subscribers).modal({
            backdrop: "static",
            keyboard: false,
          });
        }
      } else {
        this.selectedProvider = {
          reservationId: job.reservationId,
          providerId: job.providers[0],
          overrideTimingBlock: false,
        };
        await this.dispatchJob();
      }
    },
    async dispatchJob(fromModal = false, overrideTimingBlock = false) {
      const payload = { ...this.selectedProvider, overrideTimingBlock };

      const response = await availableJobService.dispatchJob(
        payload,
        this.startLoader,
        this.stopLoader,
        this.dispatchOverrideModal
      );

      if (response && response.isSuccess) {
        this.clearPayload();

        this.search().then(() => {
          if (fromModal) {
            $(this.$refs.modal_subscribers).modal("hide");
          }
          this.$notification.success("Successfully dispatched.", {
            title: "Success",
          });
        });
      }
    },
    dispatchOverrideModal(data) {
      if (
        this.userType === "TenantUser" &&
        data.errors[0].includes("JTB001|")
      ) {
        $("#OverrideConfirmation").modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    },
    cancelConfirmation() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/job/availableJob/AvailableJob.vue